//node_modules
import { useContext, createContext } from "react";

//libs
import { useClassUpdate } from "libs/useClassState";

//types
import type { PaginationState } from "./usePaginationHandler";

const context = createContext<PaginationState>(undefined as any);

export const PaginationContext = context.Provider;

export default function usePagination() {
  const state = useContext(context);
  useClassUpdate(state);
  return state;
}
